module.exports = __webpack_public_path__ + "static/media/ETHEREUM.c15aff58.png";